import React, { useContext, useState } from 'react';
import UserContext from '../context/UserContext';
import FlexColumn from '../components/shared/FlexColumn';
import Input from '../components/shared/Input';
import { API } from '../utils/API';
import { apiConfig } from '../utils/apiConfig';

export default function Login() {
  const { handleLogin } = useContext(UserContext);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [otpCode, setOtpCode] = useState('');
  const [showOTP, setShowOTP] = useState(false);
  const [loading, setLoading] = useState(false);

  const onClick = async () => {
    if (!showOTP) {
      // First step: send credentials and request OTP
      setLoading(true);
      const body = {
        mail: username,
        password: password,
      };

      try {
        const res = await API(apiConfig.admin.sendOTP, 'POST', body);

        if (res?.status && res?.requiresOTP) {
          setShowOTP(true);
        } else {
          alert(res?.message || 'Failed to send OTP');
        }
      } catch (error) {
        alert('Error sending OTP');
      } finally {
        setLoading(false);
      }
    } else {
      // Second step: verify OTP
      setLoading(true);
      const body = {
        mail: username,
        otpCode: otpCode,
      };

      try {
        const res = await API(apiConfig.admin.verifyOTP, 'POST', body);

        if (res?.status && res?.user) {
          if (res?.user?.role === 'admin' || res?.user?.role === 'view-only') {
            handleLogin({ role: res?.user?.role, loginToken: res.token });
          } else {
            alert('No permissions');
          }
        } else {
          alert(res?.message || 'Invalid OTP');
        }
      } catch (error) {
        alert('Error verifying OTP');
      } finally {
        setLoading(false);
      }
    }
  };

  const handleBackToCredentials = () => {
    setShowOTP(false);
    setOtpCode('');
  };

  return (
    <FlexColumn>
      <h1 style={styles.title}>Login</h1>

      {!showOTP ? (
        <>
          <h3 style={styles.subtitle}>Username</h3>
          <Input value={username} onChange={setUsername} />
          <h3 style={styles.subtitle}>Password</h3>
          <Input value={password} onChange={setPassword} type="password" />
          <button style={styles.button} onClick={onClick} disabled={loading}>
            {loading ? 'Sending OTP...' : 'Send OTP'}
          </button>
        </>
      ) : (
        <>
          <h3 style={styles.subtitle}>Enter OTP sent to your email</h3>
          <Input value={otpCode} onChange={setOtpCode} placeholder="Enter 6-digit code" />
          <button style={styles.button} onClick={onClick} disabled={loading}>
            {loading ? 'Verifying...' : 'Verify OTP'}
          </button>
          <button style={styles.backButton} onClick={handleBackToCredentials} disabled={loading}>
            Back to Credentials
          </button>
        </>
      )}
    </FlexColumn>
  );
}

const styles = {
  title: { marginTop: 60 },
  subtitle: { marginTop: 20 },
  button: { width: 150, height: 30, marginTop: 20, fontSize: 20 },
  backButton: { width: 150, height: 30, marginTop: 20, fontSize: 20, backgroundColor: '#ccc' },
};
